<template>
  <div class="main-content login">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Register</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="login-container">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-push-3">
            <div class="border-1px p-25">
              <h4 class="text-theme-colored text-uppercase m-0">Register Pasien</h4>
              <div class="line-bottom mb-30"></div>
              <p>
                Jika sudah memiliki akun silahkan login
                <b-link :to="{ path: '/login' }">disini</b-link>
              </p>
              <form
                id="register-form"
                name="register-form"
                class="mt-30"
                method="post"
                action
                novalidate="novalidate"
                onsubmit="return false"
              >
                <div class="row">
                  <!--<div class="col-sm-12">
	                    			<div class="form-group mb-10">
	                    				<select name="kelamin" class="form-control">
	                    					<option value="">Masukkan Jenis Kelamin</option>
	                    					<option value="1">Laki-laki</option>
	                    					<option value="2">Perempuan</option>
	                    				</select>
	                    			</div>
	                  			</div>
	                  			<div class="col-sm-12">
	                    			<div class="form-group mb-10">
	                    				<textarea name="alamat" class="form-control required" placeholder="Masukkan Alamat" rows="5" aria-required="true"></textarea>
	                    			</div>
                  </div>-->
                  <!--<div class="col-sm-12">
	                    			<div class="form-group mb-10">
	                      				<input :disabled="disabled" v-model="form_rm" name="name" class="form-control" type="text" required="" placeholder="Masukkan Nomor RM Anda" aria-required="true">
	                    			</div>
                  </div>-->
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Nama Lengkap</label>
                      <input
                        :disabled="disabled"
                        v-model="form_fullname"
                        name="name"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Masukkan Nama Lengkap"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Tanggal Lahir</label>
                      <datepicker
                        input-class="form-control"
                        :disabled="disabled"
                        :value="date"
                        :language="id"
                        format="dd MMMM yyyy"
                      ></datepicker>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Email</label>
                      <input
                        :disabled="disabled"
                        v-model="form_email"
                        name="email"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Masukkan Email Address"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Nomor Telepon</label>
                      <input
                        :disabled="disabled"
                        v-model="form_phone"
                        name="tlp"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Masukkan Nomor Telepon"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Kata Sandi</label>
                      <input
                        :disabled="disabled"
                        v-model="form_password"
                        name="password"
                        class="form-control required password"
                        type="password"
                        placeholder="Masukkan Kata Sandi"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Ulangi Kata Sandi</label>
                      <input
                        :disabled="disabled"
                        v-model="form_passconf"
                        name="password"
                        class="form-control required password"
                        type="password"
                        placeholder="Konfirmasi Kata Sandi"
                        aria-required="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0 mt-20">
                  <button
                    :disabled="disabled"
                    type="submit"
                    @click="postRegister"
                    class="btn btn-circled btn-dark btn-theme-colored"
                  >
                    <i v-if="show_loading" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                    <span v-if="!show_loading">Daftar</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { id } from "vuejs-datepicker/dist/locale";

import router from "../router";
import api from "../services/api";

export default {
  data() {
    return {
      form_rm: "",
      form_email: "",
      form_password: "",
      form_passconf: "",
      form_fullname: "",
      form_phone: "",
      disabled: false,
      show_loading: false,
      id: id,
      date: Date.now(),
    };
  },
  components: {
    Datepicker,
  },
  methods: {
    postRegister() {
      // console.log(this.form_name);
      if (
        this.form_email == "" ||
        this.form_password == "" ||
        this.form_passconf == "" ||
        this.form_phone == "" ||
        this.form_fullname == ""
      ) {
        alert("Seluruh form harus diisi dengan benar");
        this.show_loading = false;
        this.disabled = false;
      } else if (this.form_password != this.form_passconf) {
        alert("Pastikan password yang anda masukkan sama");
        this.show_loading = false;
        this.disabled = false;
      } else {
        this.show_loading = true;
        this.disabled = true;

        let payload = {
          rm: this.form_rm,
          email: this.form_email,
          password: this.form_password,
          fullname: this.form_fullname,
          phone: this.form_phone,
        };

        api
          .post(api.route.post.register, payload)
          .then((res) => {
            let status = res.status;
            let message = res.message;
            let data = res.data;
            if (status) {
              let dataLogin = {
                logged: false,
                email: data.email,
                phone: data.phone,
                rm: data.rm,
                user_privilege_id: data.user_privilege_id,
                verify: data.verify,
              };
              localStorage.setItem("user_data", JSON.stringify(dataLogin));
              router.push({ name: "verification" });
            }

            this.show_loading = false;
            this.disabled = false;
          })
          .catch((err) => {
            alert(err);

            this.show_loading = false;
            this.disabled = false;
          });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Register.vue